module.exports = __webpack_public_path__ + "img/avatar0.4efb15c1.png";